__turbopack_context__.v({
  "content": "ijpZQG_content",
  "form": "ijpZQG_form",
  "mainContent": "ijpZQG_mainContent",
  "showDesktop": "ijpZQG_showDesktop",
  "showMobile": "ijpZQG_showMobile",
});
